var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.104.146a.499.499 0 01.851.353v7.715L8.06 5.105a.499.499 0 01.705.705L4.81 9.77l-.077.062h-.02l-.065.035h-.03a.292.292 0 01-.162.018.414.414 0 01-.097 0 .277.277 0 01-.065-.018h-.03L4.2 9.831h-.02a.633.633 0 01-.074-.062L.146 5.81a.499.499 0 01.706-.705l3.105 3.121V.499c0-.133.053-.26.147-.353zM8.415 12H.5a.498.498 0 110-.997h7.916a.498.498 0 110 .997z"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--download-dfecf087e84b532904c71979ac8bce01.svg";
export { SvgIconUiDownload as Component };